var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "made-by-component" }, [
      _c("span", [
        _vm._v("\n      ©2018. Made by\n      "),
        _c("a", { attrs: { href: "https://epicmax.co" } }, [_vm._v("Epicmax")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }